import { FC } from "react";
import MyDocuments from "../pages/CitizenshipReimbursement/UploadDocument/ViewDetails/MyDocuments";
import Applications from "../pages/CitizenshipReimbursement/UploadDocument/ViewDetails/Applications";
import ManagerInfo from "../pages/CitizenshipReimbursement/UploadDocument/ViewDetails/ManagerInfo";
import ManagerInformation from "../pages/CitizenshipReimbursement/ManagerPortal/ManagerInformation";
import DocumentTab from "../pages/CitizenshipReimbursement/Admin/Citizenship/DetailsTabs/DocumentTab";
import ApplicationTab from "../pages/CitizenshipReimbursement/Admin/Citizenship/DetailsTabs/ApplicationTab";
import TuitionApplicationTab from "../pages/TuitionReimbursement/UploadDocument/DoumentsTab/TuitionApplicationTab";
import TuitionMyDocumentsTab from "../pages/TuitionReimbursement/UploadDocument/DoumentsTab/TuitionMyDocumentsTab";
import EmployeeInfo from "../pages/TuitionReimbursement/Overview/ Tabs/EmployeeInfo";
import EmployeeBalance from "../pages/TuitionReimbursement/Overview/ Tabs/EmployeeBalance";

import PendingApprovalApplications from "../pages/TuitionReimbursement/ManagerPortal/ApplicationsTabs/PendingApprovalApplications";
import PastApplications from "../pages/TuitionReimbursement/ManagerPortal/ApplicationsTabs/PastApplications";
import AppplicantInformation from "../pages/TuitionReimbursement/ManagerPortal/ViewsDetailsTabs/ApplicantInformation";
import EmploymentInformation from "../pages/TuitionReimbursement/ManagerPortal/ViewsDetailsTabs/EmploymentInformation";
import SchoolInformation from "../pages/TuitionReimbursement/ManagerPortal/ViewsDetailsTabs/SchoolInformation";
import ClassInformation from "../pages/TuitionReimbursement/ManagerPortal/ViewsDetailsTabs/ClassInformation";
import OtherApplications from "../pages/TuitionReimbursement/ManagerPortal/ViewsDetailsTabs/OtherApplications";
import ReimbursmentTab from "../pages/CitizenshipReimbursement/Admin/Citizenship/DetailsTabs/ReimbursmentTab";
import TuitionReimbursmentTab from "../pages/TuitionReimbursement/Admin/Tuition/DetailsTabs/TuitionReimbursement";
import Comments from "../pages/TuitionReimbursement/Admin/Tuition/DetailsTabs/Comments";
import Documents from "../pages/TuitionReimbursement/Admin/Tuition/DetailsTabs/Documents/Documents";
import Email from "../pages/TuitionReimbursement/Admin/Tuition/DetailsTabs/Email";
import Balances from "../pages/TuitionReimbursement/Admin/Tuition/DetailsTabs/Balances";
import AllApplicationDetails from "../pages/TuitionReimbursement/Admin/Tuition/DetailsTabs/AllApplicationsDetails";

export interface TabData {
  id: number;
  title: string;
  component: FC<any>;
}

export const viewDetailsTabsData: TabData[] = [
  {
    id: 1,
    title: "My Documents",
    component: MyDocuments,
  },
  {
    id: 2,
    title: "Applications",
    component: Applications,
  },
  {
    id: 3,
    title: "Manager Information",
    component: ManagerInfo,
  },
];

export const managerPortalTabsData: TabData[] = [
  {
    id: 1,
    title: "Application",
    component: Applications,
  },
  {
    id: 2,
    title: "Manager information",
    component: ManagerInformation,
  },
];

export const adminDetailsTabsData: TabData[] = [
  {
    id: 1,
    title: "Reimbursement",
    component: ReimbursmentTab,
  },
  {
    id: 2,
    title: "Document",
    component: DocumentTab,
  },
  {
    id: 3,
    title: "Application",
    component: ApplicationTab,
  },
];

export const tuitionViewTabsData: TabData[] = [
  {
    id: 1,
    title: "My Documents",
    component: TuitionMyDocumentsTab,
  },
  {
    id: 2,
    title: "Application",
    component: TuitionApplicationTab,
  },
];

export const OverviewTabsData: TabData[] = [
  {
    id: 1,
    title: "Employee information",
    component: EmployeeInfo,
  },
  {
    id: 2,
    title: "Employee balance",
    component: EmployeeBalance,
  },
];
//Tuition manager portal  tabs
 
export const tuitionManagerPortalTabsData: TabData[] = [
  {
    id: 1,
    title: "Pending approval applications",
    component: PendingApprovalApplications,
  },
  {
    id: 3,
    title: "Past applications",
    component: PastApplications,
  },
];
 
//Tuiition manager portal view details tabs
 
export const tuitionManagerViewDetailsTabsData: TabData[] = [
  {
    id: 1,
    title: "Applicant information",
    component: AppplicantInformation,
  },
  {
    id: 2,
    title: "Employment information",
    component: EmploymentInformation,
  },
  {
    id: 3,
    title: "School information",
    component: SchoolInformation,
  },
  {
    id: 4,
    title: "Class information",
    component: ClassInformation,
  },
  {
    id: 5,
    title: "Other applications",
    component: OtherApplications,
  },
];
export const tuitionAdminDetailsTabsData: TabData[] = [
  {
    id: 1,
    title: "Reimbursement",
    component: TuitionReimbursmentTab,
  },
  {
    id: 2,
    title: "Balances",
    component: Balances,
  },{
    id: 3,
    title: "Documents",
    component: Documents,
  },
  {
    id: 4,
    title: "Application",
   component: AllApplicationDetails,
  },
    {
    id: 5,
    title: "Email",
    component: Email,
  },
     {
    id: 6,
    title: "Comments",
    component: Comments,
  },
];
